module.exports = __webpack_public_path__ + "img/law-serve-nav-icon05.d8d3757c.png";